import { null as zNull } from "zod";

export const disconnectRivoIntegration = { input: zNull(), output: zNull() };
